import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Loader from 'examples/Loader'
import CustomDataTable from '../Users/CustomDataTable'
import AppData from './components/data-tables/data/dataTableData'

function LinkInBio() {
  const {
    dataTableData,
    loader,
    pagination,
    handlePageChange,
    handleLimitChange,
  } = AppData()

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" color="white">
                      Link in Bio — Instagram Posts
                    </MDTypography>
                  </MDBox>

                  <MDBox pt={3} px={3}>
                    <CustomDataTable
                      table={dataTableData}
                      canSearch={false}
                      entriesPerPage={{
                        defaultValue: pagination?.limit || 24,
                        entries: [12, 24, 48, 100],
                      }}
                      pagination={pagination}
                      onPageChange={handlePageChange}
                      onLimitChange={handleLimitChange}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  )
}

export default LinkInBio
